// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin_login_css {
  margin-top: 90px !important;
}
.aws-p {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 5px 0;
}
.aws-p1 {
  margin: 0 0 0 0;
  font-size: 14px;
}
.card-admin {
  background: #fff;
  padding: 30px 20px;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border-radius: 12px;
  height: calc(100% - 30px);
  margin: 0 0 30px 0;
}
.aws-p {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 5px 0;
}
.aws-p1 {
  margin: 0 0 0 0;
  font-size: 14px;
}
.table-90 {
  width: 100%;
}
.card-table {
  background: #fff;
  padding: 30px 20px;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border-radius: 12px;
  overflow: auto;
  margin: 15px 0;
}
.table-90 thead tr th {
  font-size: 14px;
  background: #17c1e8;
  color: #fff;
  padding: 10px 15px;
}
.table-90 tbody tr td {
  font-size: 14px;
  background: #ffffff;
  color: #fff;
  padding: 10px 15px;
  color: #000;
}
.table-90 tbody tr:nth-child(even) td {
  background: #17c1e80d;
}
.card-admin {
  background: #fff;
  padding: 30px 20px;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border-radius: 12px;
}
.aws-p {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 5px 0;
}
.aws-p1 {
  margin: 0 0 0 0;
  font-size: 14px;
}
.table-90 {
  width: 100%;
}
.card-table {
  background: #fff;
  padding: 30px 20px;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border-radius: 12px;
  overflow: auto;
  margin: 15px 0;
}
.table-90 thead tr th {
  font-size: 14px;
  background: #17c1e8;
  color: #fff;
  padding: 10px 15px;
}
.table-90 tbody tr td {
  font-size: 14px;
  background: #ffffff;
  color: #fff;
  padding: 10px 15px;
  color: #000;
}
.table-90 tbody tr:nth-child(even) td {
  background: #17c1e80d;
}
.Search-input {
  background: #fff;
  padding: 0px 15px;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border-radius: 6px;
  border: none;
  height: 40px;
  margin: 0 15px 0 0;
}
.Search-bt {
  background: #17c1e8;
  padding: 0px 15px;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border-radius: 6px;
  border: none;
  height: 40px;
  margin: 0 15px 0 0;
  color: #fff;
  font-weight: bold;
}
.Search-div {
  margin: 30px 0 0 0;
}

.privacyPolicy_css {
  background: #fff;
  border: #0000;
  border-radius: 18px;
  box-shadow: 0 8px 24px #959da512;
  outline: none;
  padding: 40px;
}

.privacyPolicy_css h1 {
  color: #17c1e8;
  font-size: 40px !important;
  margin: 0 0 22px;
}
.privacyPolicy_css h2 {
  font-size: 20px !important;
  font-weight: 500;
}

.privacyPolicy_css p {
  color: #67748e;
  margin: 0 0 22px;
}

.card-title {
  color: #262626;
  font-size: 1.5em;
  line-height: normal;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 0.5em;
}

.small-desc {
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5em;
  color: #452c2c;
}

.go-corner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 2em;
  height: 2em;
  overflow: hidden;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #6293c8, #384c6c);
  border-radius: 0 4px 0 32px;
}

.go-arrow {
  margin-top: -4px;
  margin-right: -4px;
  color: white;
  font-family: courier, sans;
}

.dashboardCard {
  display: block;
  position: relative;
  max-width: 100% !important;
  max-height: initial;
  background-color: #f2f8f9;
  border-radius: 10px;
  padding: 2em 1.2em;
  margin: 12px;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
  background: linear-gradient(to bottom, #c3e6ec, #a7d1d9);
  font-family: Arial, Helvetica, sans-serif;
  cursor: "pointer";
  width: 100%;
  height: calc(100% - 15px);
  text-align: right;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: "box-shadow 0.3s ease-in-out";
  margin: 0 0 0 0 !important;
}

/* .dashboardCard {
  display: block;
  position: relative;
  max-width: 100% !important;
  max-height: 320px;
  background-color: #f2f8f9;
  border-radius: 10px;
  padding: 2em 1.2em;
  margin: 12px;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
  background: linear-gradient(to bottom, #c3e6ec, #a7d1d9);
  font-family: Arial, Helvetica, sans-serif;
  cursor: "pointer";
  width: 94%;
  height: 45vh;
  text-align: right;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: "box-shadow 0.3s ease-in-out";
} */

.dashboardCard:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -16px;
  right: -16px;
  background: linear-gradient(135deg, #364a60, #99b3dc);
  height: 32px;
  width: 32px;
  border-radius: 32px;
  transform: scale(1);
  transform-origin: 50% 50%;
  transition: transform 0.35s ease-out;
}

.dashboardCard:hover:before {
  transform: scale(28);
}

.dashboardCard:hover .dashboardCard-desc {
  transition: all 0.5s ease-out;
  color: rgba(255, 255, 255, 0.8);
}

.dashboardCard:hover .dashboardCard-title {
  transition: all 0.5s ease-out;
  color: #ffffff;
}

.dashboardCard-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.faq-list {
  margin-top: 20px;
}

.faq-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}

.faq-text {
  margin: 0;
  flex-grow: 1;
}

.faq-actions {
  display: flex;
  gap: 10px;
}

.faq-input,
.faq-textarea {
  width: 100%;
  max-width: 400px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  margin-bottom: 10px;
}

.faq-button {
  padding: 10px 15px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.faq-button:hover {
  background-color: #007bff;
  color: white;
}

.edit-button {
  background-color: #ffcc00;
}

.delete-button {
  background-color: #ff4d4d;
  color: white;
}

.save-button {
  background-color: #28a745;
  color: white;
}

.qr-web-container {
  text-align: center;
  margin: 20px;
}

.qr-header {
  margin: 20px 0;
}

.logo {
  width: 50px;
}
.logoqr {
  width: 100px;
}

.main-content {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 50px;
  margin-top: 30px;
}

.instructions {
  text-align: left;
  max-width: 400px;
}

.instructions ol {
  padding-left: 20px;
}

.instructions a {
  display: block;
  margin-top: 10px;
  color: #0088cc;
  text-decoration: none;
}

.instructions a:hover {
  text-decoration: underline;
}

.qr-code-container {
  text-align: center;
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.checkbox-container {
  margin-top: 10px;
}

.footer {
  margin-top: 0px;
  color: gray;
  font-size: 14px;
}

.tiktok {
  text-align: center;
  color: white;
  background-color: #000;
  border-radius: 20px;
}

@media (max-width: 767px) {
  .faq_css {
    width: 90%;
    padding: 30px 30px;
  }

  .main-content {
    flex-wrap: wrap;
  }
}

.tiktoklogo {
  width: 100px;
}

.home-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.header {
  display: flex;
  align-items: center;

  color: white;
  padding: 0 20px;
}

.header .logo img {
  margin-right: 20px;
}

.header-title {
  color: white !important;
  margin: 0;
}

.content {
  padding: 50px;
  text-align: center;
}

.hero-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
}

.hero-image {
  max-width: 300px;
  border-radius: 10px;
}

.hero-text {
  max-width: 500px;
  text-align: left;
}

.footer {
  color: white;
  padding: 0 20px;
}

@media (max-width: 576px) {
  .ant-avatar {
    width: 60px !important;
    height: 60px !important;
  }

  .ant-typography-title {
    font-size: 16px !important;
  }

  .ant-btn {
    font-size: 12px !important;
  }
}

.UserChat_css {
  background: #f9f9f9;
  padding: 5px;
  display: flex;
  border-radius: 10px;
  box-shadow: 3px 3px 5px #c2cdd0;
  text-align: center;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  position: relative;
}
.UserChat_css p {
  margin: 0px;
}

.UserChat_css img {
  height: 50px;
  width: 60px;
}

.chat_img_css {
  position: relative;
  left: 0;
}

.userchat_text_css {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 215px;
  display: inline-block;
}

.history_css {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.user_history_dropdown_css {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subscription-container {
  text-align: center;
  padding: 20px;
}

.subscription-heading {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #333;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.subscription-card {
  width: 280px;
  margin: 20px;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.subscription-card:hover {
  transform: scale(1.05);
}

.card-icon {
  margin-bottom: 20px;
}

.bronze-icon {
  font-size: 48px;
  color: #a75709;
}

.silver-icon {
  font-size: 48px;
  color: #e7dddd;
}

.gold-icon {
  font-size: 48px;
  color: #b7a547;
}

.platinum-icon {
  font-size: 48px;
  color: #b7b4b0;
}

.black-icon {
  font-size: 48px;
  color: #fff;
}

.card-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.black .card-title {
  color: #fff;
}

.card-description {
  margin-top: 10px;
}

.card-text {
  white-space: pre-line;
  font-size: 16px;
  color: #555;
}

.black .card-text {
  color: #eee;
}

.card-price {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;
  color: #333;
}

.black .card-price {
  color: #fff;
}

.black .card-entry {
  color: #fff;
}

.card-button {
  width: 100%;
  border-radius: 8px;
  font-weight: bold;
}

.bronze-button {
  background-color: #1890ff;
  border-color: #1890ff;
}

.silver-button {
  background-color: #1890ff;
  border-color: #1890ff;
}

.gold-button {
  background-color: #1890ff;
  border-color: #1890ff;
}

.platinum-button {
  background-color: #1890ff;
  border-color: #1890ff;
}

.black-button {
  background-color: #333;
  border-color: #333;
}

.toggle-black-card {
  margin-top: 30px;
  background-color: #333;
  border-color: #333;
  border-radius: 8px;
  font-weight: bold;
  padding: 0 24px;
  height: 40px;
}

.subscription-tabs {
  margin-bottom: 20px;
}

.subscription-tabs .ant-tabs-tab {
  font-size: 16px;
  font-weight: bold;
}

.subscription-tabs .ant-tabs-tab-active {
  color: #1890ff;
}

.subscription-container {
  padding: 20px;
}

.create-plan-button {
  margin-bottom: 20px;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.subscription-card {
  width: 300px;
  border-radius: 10px;
  color: white;
}

.card-icon {
  font-size: 40px;
  text-align: center;
  margin-bottom: 20px;
}

.card-title {
  font-size: 24px;
  font-weight: bold;
}

.card-text {
  font-size: 14px;
}

.card-price {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
}

.card-button {
  width: 100%;
}

.toggle-black-card {
  margin-top: 20px;
}

.subscription-card {
  border: 1px solid #ccc;
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
  min-height: 400px;
}

.edit-form {
  border: 1px solid #ccc;
  padding: 20px;
  margin-top: 20px;
  border-radius: 5px;
}

.edit-form label {
  display: block;
  margin-bottom: 10px;
}

.edit-form input,
.edit-form textarea {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
}

.edit-form button {
  margin-right: 10px;
}

.card-buttons {
  display: flex;
  gap: 10px;
}

.card-buttons .card-button {
  flex: 1 1;
}

.black-card-text {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/style/admin.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,wDAAwD;EACxD,yCAAyC;EACzC,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;EACzC,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;AACd","sourcesContent":[".admin_login_css {\n  margin-top: 90px !important;\n}\n.aws-p {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0 0 5px 0;\n}\n.aws-p1 {\n  margin: 0 0 0 0;\n  font-size: 14px;\n}\n.card-admin {\n  background: #fff;\n  padding: 30px 20px;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border-radius: 12px;\n  height: calc(100% - 30px);\n  margin: 0 0 30px 0;\n}\n.aws-p {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0 0 5px 0;\n}\n.aws-p1 {\n  margin: 0 0 0 0;\n  font-size: 14px;\n}\n.table-90 {\n  width: 100%;\n}\n.card-table {\n  background: #fff;\n  padding: 30px 20px;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border-radius: 12px;\n  overflow: auto;\n  margin: 15px 0;\n}\n.table-90 thead tr th {\n  font-size: 14px;\n  background: #17c1e8;\n  color: #fff;\n  padding: 10px 15px;\n}\n.table-90 tbody tr td {\n  font-size: 14px;\n  background: #ffffff;\n  color: #fff;\n  padding: 10px 15px;\n  color: #000;\n}\n.table-90 tbody tr:nth-child(even) td {\n  background: #17c1e80d;\n}\n.card-admin {\n  background: #fff;\n  padding: 30px 20px;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border-radius: 12px;\n}\n.aws-p {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 0 0 5px 0;\n}\n.aws-p1 {\n  margin: 0 0 0 0;\n  font-size: 14px;\n}\n.table-90 {\n  width: 100%;\n}\n.card-table {\n  background: #fff;\n  padding: 30px 20px;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border-radius: 12px;\n  overflow: auto;\n  margin: 15px 0;\n}\n.table-90 thead tr th {\n  font-size: 14px;\n  background: #17c1e8;\n  color: #fff;\n  padding: 10px 15px;\n}\n.table-90 tbody tr td {\n  font-size: 14px;\n  background: #ffffff;\n  color: #fff;\n  padding: 10px 15px;\n  color: #000;\n}\n.table-90 tbody tr:nth-child(even) td {\n  background: #17c1e80d;\n}\n.Search-input {\n  background: #fff;\n  padding: 0px 15px;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border-radius: 6px;\n  border: none;\n  height: 40px;\n  margin: 0 15px 0 0;\n}\n.Search-bt {\n  background: #17c1e8;\n  padding: 0px 15px;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border-radius: 6px;\n  border: none;\n  height: 40px;\n  margin: 0 15px 0 0;\n  color: #fff;\n  font-weight: bold;\n}\n.Search-div {\n  margin: 30px 0 0 0;\n}\n\n.privacyPolicy_css {\n  background: #fff;\n  border: #0000;\n  border-radius: 18px;\n  box-shadow: 0 8px 24px #959da512;\n  outline: none;\n  padding: 40px;\n}\n\n.privacyPolicy_css h1 {\n  color: #17c1e8;\n  font-size: 40px !important;\n  margin: 0 0 22px;\n}\n.privacyPolicy_css h2 {\n  font-size: 20px !important;\n  font-weight: 500;\n}\n\n.privacyPolicy_css p {\n  color: #67748e;\n  margin: 0 0 22px;\n}\n\n.card-title {\n  color: #262626;\n  font-size: 1.5em;\n  line-height: normal;\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 0.5em;\n}\n\n.small-desc {\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 1.5em;\n  color: #452c2c;\n}\n\n.go-corner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  width: 2em;\n  height: 2em;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  background: linear-gradient(135deg, #6293c8, #384c6c);\n  border-radius: 0 4px 0 32px;\n}\n\n.go-arrow {\n  margin-top: -4px;\n  margin-right: -4px;\n  color: white;\n  font-family: courier, sans;\n}\n\n.dashboardCard {\n  display: block;\n  position: relative;\n  max-width: 100% !important;\n  max-height: initial;\n  background-color: #f2f8f9;\n  border-radius: 10px;\n  padding: 2em 1.2em;\n  margin: 12px;\n  text-decoration: none;\n  z-index: 0;\n  overflow: hidden;\n  background: linear-gradient(to bottom, #c3e6ec, #a7d1d9);\n  font-family: Arial, Helvetica, sans-serif;\n  cursor: \"pointer\";\n  width: 100%;\n  height: calc(100% - 15px);\n  text-align: right;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  transition: \"box-shadow 0.3s ease-in-out\";\n  margin: 0 0 0 0 !important;\n}\n\n/* .dashboardCard {\n  display: block;\n  position: relative;\n  max-width: 100% !important;\n  max-height: 320px;\n  background-color: #f2f8f9;\n  border-radius: 10px;\n  padding: 2em 1.2em;\n  margin: 12px;\n  text-decoration: none;\n  z-index: 0;\n  overflow: hidden;\n  background: linear-gradient(to bottom, #c3e6ec, #a7d1d9);\n  font-family: Arial, Helvetica, sans-serif;\n  cursor: \"pointer\";\n  width: 94%;\n  height: 45vh;\n  text-align: right;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  transition: \"box-shadow 0.3s ease-in-out\";\n} */\n\n.dashboardCard:before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: -16px;\n  right: -16px;\n  background: linear-gradient(135deg, #364a60, #99b3dc);\n  height: 32px;\n  width: 32px;\n  border-radius: 32px;\n  transform: scale(1);\n  transform-origin: 50% 50%;\n  transition: transform 0.35s ease-out;\n}\n\n.dashboardCard:hover:before {\n  transform: scale(28);\n}\n\n.dashboardCard:hover .dashboardCard-desc {\n  transition: all 0.5s ease-out;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.dashboardCard:hover .dashboardCard-title {\n  transition: all 0.5s ease-out;\n  color: #ffffff;\n}\n\n.dashboardCard-line {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.faq-list {\n  margin-top: 20px;\n}\n\n.faq-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #ccc;\n  padding: 10px 0;\n}\n\n.faq-text {\n  margin: 0;\n  flex-grow: 1;\n}\n\n.faq-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.faq-input,\n.faq-textarea {\n  width: 100%;\n  max-width: 400px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.faq-button {\n  padding: 10px 15px;\n  font-size: 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.faq-button:hover {\n  background-color: #007bff;\n  color: white;\n}\n\n.edit-button {\n  background-color: #ffcc00;\n}\n\n.delete-button {\n  background-color: #ff4d4d;\n  color: white;\n}\n\n.save-button {\n  background-color: #28a745;\n  color: white;\n}\n\n.qr-web-container {\n  text-align: center;\n  margin: 20px;\n}\n\n.qr-header {\n  margin: 20px 0;\n}\n\n.logo {\n  width: 50px;\n}\n.logoqr {\n  width: 100px;\n}\n\n.main-content {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 50px;\n  margin-top: 30px;\n}\n\n.instructions {\n  text-align: left;\n  max-width: 400px;\n}\n\n.instructions ol {\n  padding-left: 20px;\n}\n\n.instructions a {\n  display: block;\n  margin-top: 10px;\n  color: #0088cc;\n  text-decoration: none;\n}\n\n.instructions a:hover {\n  text-decoration: underline;\n}\n\n.qr-code-container {\n  text-align: center;\n  background-color: white;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.checkbox-container {\n  margin-top: 10px;\n}\n\n.footer {\n  margin-top: 0px;\n  color: gray;\n  font-size: 14px;\n}\n\n.tiktok {\n  text-align: center;\n  color: white;\n  background-color: #000;\n  border-radius: 20px;\n}\n\n@media (max-width: 767px) {\n  .faq_css {\n    width: 90%;\n    padding: 30px 30px;\n  }\n\n  .main-content {\n    flex-wrap: wrap;\n  }\n}\n\n.tiktoklogo {\n  width: 100px;\n}\n\n.home-page {\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n\n  color: white;\n  padding: 0 20px;\n}\n\n.header .logo img {\n  margin-right: 20px;\n}\n\n.header-title {\n  color: white !important;\n  margin: 0;\n}\n\n.content {\n  padding: 50px;\n  text-align: center;\n}\n\n.hero-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.hero-image {\n  max-width: 300px;\n  border-radius: 10px;\n}\n\n.hero-text {\n  max-width: 500px;\n  text-align: left;\n}\n\n.footer {\n  color: white;\n  padding: 0 20px;\n}\n\n@media (max-width: 576px) {\n  .ant-avatar {\n    width: 60px !important;\n    height: 60px !important;\n  }\n\n  .ant-typography-title {\n    font-size: 16px !important;\n  }\n\n  .ant-btn {\n    font-size: 12px !important;\n  }\n}\n\n.UserChat_css {\n  background: #f9f9f9;\n  padding: 5px;\n  display: flex;\n  border-radius: 10px;\n  box-shadow: 3px 3px 5px #c2cdd0;\n  text-align: center;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.UserChat_css p {\n  margin: 0px;\n}\n\n.UserChat_css img {\n  height: 50px;\n  width: 60px;\n}\n\n.chat_img_css {\n  position: relative;\n  left: 0;\n}\n\n.userchat_text_css {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 215px;\n  display: inline-block;\n}\n\n.history_css {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.user_history_dropdown_css {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.subscription-container {\n  text-align: center;\n  padding: 20px;\n}\n\n.subscription-heading {\n  font-size: 36px;\n  font-weight: bold;\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.card-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.subscription-card {\n  width: 280px;\n  margin: 20px;\n  text-align: center;\n  border-radius: 15px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  transition: transform 0.3s ease;\n}\n\n.subscription-card:hover {\n  transform: scale(1.05);\n}\n\n.card-icon {\n  margin-bottom: 20px;\n}\n\n.bronze-icon {\n  font-size: 48px;\n  color: #a75709;\n}\n\n.silver-icon {\n  font-size: 48px;\n  color: #e7dddd;\n}\n\n.gold-icon {\n  font-size: 48px;\n  color: #b7a547;\n}\n\n.platinum-icon {\n  font-size: 48px;\n  color: #b7b4b0;\n}\n\n.black-icon {\n  font-size: 48px;\n  color: #fff;\n}\n\n.card-title {\n  font-size: 28px;\n  font-weight: bold;\n  color: #333;\n}\n\n.black .card-title {\n  color: #fff;\n}\n\n.card-description {\n  margin-top: 10px;\n}\n\n.card-text {\n  white-space: pre-line;\n  font-size: 16px;\n  color: #555;\n}\n\n.black .card-text {\n  color: #eee;\n}\n\n.card-price {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 20px 0;\n  color: #333;\n}\n\n.black .card-price {\n  color: #fff;\n}\n\n.black .card-entry {\n  color: #fff;\n}\n\n.card-button {\n  width: 100%;\n  border-radius: 8px;\n  font-weight: bold;\n}\n\n.bronze-button {\n  background-color: #1890ff;\n  border-color: #1890ff;\n}\n\n.silver-button {\n  background-color: #1890ff;\n  border-color: #1890ff;\n}\n\n.gold-button {\n  background-color: #1890ff;\n  border-color: #1890ff;\n}\n\n.platinum-button {\n  background-color: #1890ff;\n  border-color: #1890ff;\n}\n\n.black-button {\n  background-color: #333;\n  border-color: #333;\n}\n\n.toggle-black-card {\n  margin-top: 30px;\n  background-color: #333;\n  border-color: #333;\n  border-radius: 8px;\n  font-weight: bold;\n  padding: 0 24px;\n  height: 40px;\n}\n\n.subscription-tabs {\n  margin-bottom: 20px;\n}\n\n.subscription-tabs .ant-tabs-tab {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.subscription-tabs .ant-tabs-tab-active {\n  color: #1890ff;\n}\n\n.subscription-container {\n  padding: 20px;\n}\n\n.create-plan-button {\n  margin-bottom: 20px;\n}\n\n.card-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.subscription-card {\n  width: 300px;\n  border-radius: 10px;\n  color: white;\n}\n\n.card-icon {\n  font-size: 40px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.card-title {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.card-text {\n  font-size: 14px;\n}\n\n.card-price {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.card-button {\n  width: 100%;\n}\n\n.toggle-black-card {\n  margin-top: 20px;\n}\n\n.subscription-card {\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin: 10px 0;\n  border-radius: 5px;\n  min-height: 400px;\n}\n\n.edit-form {\n  border: 1px solid #ccc;\n  padding: 20px;\n  margin-top: 20px;\n  border-radius: 5px;\n}\n\n.edit-form label {\n  display: block;\n  margin-bottom: 10px;\n}\n\n.edit-form input,\n.edit-form textarea {\n  width: 100%;\n  padding: 8px;\n  margin-top: 5px;\n}\n\n.edit-form button {\n  margin-right: 10px;\n}\n\n.card-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.card-buttons .card-button {\n  flex: 1;\n}\n\n.black-card-text {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
